import { Component, OnChanges, OnDestroy, OnInit,AfterViewInit, SimpleChanges, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { candidateModel } from 'src/app/services/candidateModel';
import { JobService } from 'src/app/services/job.service';
import { UtilService } from 'src/app/services/util.service';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { TimezoneDatePipe } from '../../../timezone-date.pipe';
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { ConnectionTemplateComponent } from '../../../templates/connection-template/connection-template.component';
import { MessageWidgetComponent } from '../../../widget/message-widget/message-widget.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


import { ScrollIntentGate } from 'src/app/shared/scroll-intent-gate';
@Component({
  selector: 'app-candidate-viewed-by',
  standalone: true,
  imports: [CommonModule, InfiniteScrollModule, TimezoneDatePipe, CommonSkeletonComponent,
ConnectionTemplateComponent, MessageWidgetComponent,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './candidate-viewed-by.component.html',
  styleUrls: ['./candidate-viewed-by.component.scss'],
  inputs: ['candidateDetails', 'designVersion']
})
export class CandidateViewedByComponent implements OnInit, OnChanges, OnDestroy ,AfterViewInit{
  // User-intent gate (src/app/shared/scroll-intent-gate.ts): after a page
  // lands, the next page needs a NEW physical input — a fast wheel flick's
  // smooth-scroll tail must not chain pages on its own.
  readonly scrollGate = new ScrollIntentGate({
    onArmAtBottom: () => this.onScrollDown(),
    isAtBottom: () => ScrollIntentGate.nearBottom(document.querySelector('.jc-v3-entity-details-body')),
  });

  // Subscription lifetime — cleanup hook for every `.subscribe(...)` in
  // this component. Parent tab re-mounts this on tab swap, so without
  // the pipe each hop leaks observables. Emit + complete in ngOnDestroy.
  private destroy$ = new Subject<void>();
  @ViewChild('scrollSentinel') scrollSentinel: ElementRef;
  private intersectionObserver: IntersectionObserver | null = null;
  stopscrollFlag: boolean = false
  candidateId: any;
  candidateDetails: candidateModel;
  designVersion: string;
  values: any;
  counterpartsDetails: any;
  url = AppSettings.photoUrl;
  connectionRequestRef: BsModalRef;
  connectionStatus: string;
  LoginUserId=localStorage.getItem('userId')
  loadAPIcall:boolean=false;
  // Sentinel pagination: a page is requested only when the bottom sentinel
  // ENTERS view (the user scrolled it in). If it enters while a page is
  // already loading, the trigger is remembered and the observer is re-armed
  // once that page has landed (afterPageSettled), so the list never sticks
  // waiting for a scroll-up-then-down — and it never chains pages on its own
  // (no scroll listener: momentum scroll events must not count as new scrolls).
  private pendingSentinelTrigger = false;
  private afterPageSettled(): void {
    if (!this.pendingSentinelTrigger) return;
    this.pendingSentinelTrigger = false;
    setTimeout(() => this.setupScrollObserver());
  }

  constructor(private api: ApiService, private router: Router,private modalService: BsModalService, private util: UtilService, private a_route: ActivatedRoute,
    private JobServicecolor: JobService) {
    this.a_route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(res => {
      this.candidateId = res.candidateId
    })
  }
 ngAfterViewInit(): void {
    this.setupScrollObserver();
  }

  private setupScrollObserver(): void {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      this.intersectionObserver = null;
    }
    if (!this.scrollSentinel?.nativeElement) return;

    this.intersectionObserver = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        if (this.loadAPIcall) { this.pendingSentinelTrigger = true; return; }
        this.onScrollDown();
      },
      { root: null, rootMargin: '200px', threshold: 0 }
    );
    this.intersectionObserver.observe(this.scrollSentinel.nativeElement);
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.candidateDetails && changes.candidateDetails.currentValue) {
      this.candidateDetails = changes.candidateDetails.currentValue;
      if (this.candidateDetails.candidateId) {
        this.viewedList=[];
        this.searchConfig.pageNumber=0;
               this.stopscrollFlag=false;
        // Invalidate any in-flight page fetch and unlock the loadAPIcall
        // entry guard — a tab re-click during pagination must reload
        // fresh, not skip + append the stale page into the cleared list.
        this.fetchGeneration++;
        this.loadAPIcall = false; this.scrollGate.pageLanded();
        this.afterPageSettled();
        this.getViews()
      }
    }
       setTimeout(() => this.setupScrollObserver());
  }

  getInitialstwo(firstname: string, lastname: string): string {
    return this.JobServicecolor.getInitialsparam(firstname, lastname);
  }

  getColortwo(firstname: string, lastname: string): string {
    return this.JobServicecolor.getColorparam(firstname, lastname);
  }
  getTextColor(firstname: string, lastname: string): string {
    return this.JobServicecolor.getTextColor(firstname, lastname);
  }

  viewedList: any = []
  ngOnInit() {
    this.scrollGate.attach();
    this.viewedList=[];
    this.scrollSubject.pipe(
      debounceTime(100),
      takeUntil(this.destroy$)
    ).subscribe(() => {
      if (this.loadAPIcall || this.stopscrollFlag) return;
      this.getViews();
    });
  }

  /** Route to the viewer's public profile. Parity with /newjobs
   *  `jobs-viewed-by.profile()` — clicking a viewer's avatar or name on
   *  the candidate-side Views tab now navigates the same way. Baseline
   *  V2 candidate-side tab didn't wire this, so it's net-new; kept here
   *  so the two sides behave symmetrically. */
  profile(userId: any): void {
    if (!userId) return;
    this.router.navigate(['personalProfile'], { queryParams: { userId } });
  }

  // Cleanup all tracked subscriptions: queryParams, findCandidatesViewedBy,
  // user/:userId lookup. Without this, every tab swap that re-mounts this
  // component leaks one observable per in-flight call.
  ngOnDestroy(): void {
    this.scrollGate.detach();
    this.destroy$.next();
    this.destroy$.complete();
     if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
  }

  searchConfig: any = {
    pageNumber: 0,
  }


  // Stale-response gate: bumped on every list reset (tab re-click). A fetch
  // captures the value at launch; a reset mid-flight makes the late response
  // a no-op instead of appending old rows into the cleared list.
  private fetchGeneration = 0;
  getViews() {
         if (this.loadAPIcall) return;
    const reqCandidateId = this.candidateDetails?.candidateId;
    this.searchConfig = { ...this.searchConfig, candidateId: reqCandidateId, limit: 10, };

    this.loadAPIcall=true;
    const gen = this.fetchGeneration;
    this.api.create('candidates/findCandidatesViewedBy', this.searchConfig).pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        if (gen !== this.fetchGeneration) return;
        if (reqCandidateId !== this.candidateDetails?.candidateId) return;
        this.handleResponse(res);
      },
      err => {
        if (gen !== this.fetchGeneration) return;
        if (reqCandidateId !== this.candidateDetails?.candidateId) return;
        this.handleError(err);
      }
    );
  }

  handleResponse(res) {
    this.loadAPIcall = false; this.scrollGate.pageLanded();
    this.afterPageSettled();

    if (res.code !== '00000' || !res.data || !res.data.viewedByList.length) {
      this.stopscrollFlag = true;
      return;
    }

    if (res.code === '00000') {


      if (!this.stopscrollFlag) {
        this.searchConfig.pageNumber++;
      }

      res.data.viewedByList.forEach(element => {
        if (element.logo) {
          element.logo = AppSettings.photoUrl + element.logo;
        } else {
          element.logo = null;
        }
       // this.viewedList.push(element);
        const existingCandidate = this.viewedList.find(item => item.userId === element.userId);
        if (!existingCandidate) {
          this.viewedList.push(element);
        }
      });
    }
  }

  handleError(err) {
    this.util.stopLoader();
  }



  scrollSubject = new Subject<void>();
  onScrollDown() {
    if (!this.loadAPIcall && !this.stopscrollFlag && this.scrollGate.armed) {
      this.scrollSubject.next();
    }
  }
  chatuser(values,connectionTemplate?: TemplateRef<any>){
    if (values.connectionStatus === 'CONNECTED') {
      this.openMessage(values)
    } else if (values.connectionStatus !== 'CONNECTED') {
      this.openMessage(values)
      // to be used later
      // this.openConnectionTemplate(values.connectionStatus, values, connectionTemplate);
    }
  }
  openConnectionTemplate(connectionStatus, values, connectionTempate?: TemplateRef<any>) {
    this.connectionStatus = connectionStatus;
    this.values = values;
    const initialState: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      size: 'sm',
    };
    this.api.query("user/" + this.values.userId).pipe(takeUntil(this.destroy$)).subscribe(res => {
      if (res.code == '00000') {
        this.counterpartsDetails = res;
        this.connectionRequestRef = this.modalService.show(connectionTempate, initialState);
      }
    })
  }
  seletedChatItem:any;
  messageData: any;
  userId = localStorage.getItem('userId');
  messagemodelflag: any;
  openMessage(seletedItem) {
    if (seletedItem.userId == this.userId) {
      seletedItem.owner = true;
    } else {
      seletedItem.owner = false;
    }

    setTimeout(() => {
      seletedItem.userId = seletedItem.userId;
      this.seletedChatItem = seletedItem;
      this.messageData = [];
      this.messagemodelflag = true;
      seletedItem.groupType = "USER";
      seletedItem.messageType = "USER";
      seletedItem.id = seletedItem.userId;
      seletedItem.onlyuser ="USER";
      this.messageData = seletedItem;
    }, 1000);
  }

    closeMessage(event) {
    this.messagemodelflag = false;
  }



}
